import { render, staticRenderFns } from "./AddConsumptionGaugeWidget.vue?vue&type=template&id=23c88bbc"
import script from "./AddConsumptionGaugeWidget.vue?vue&type=script&lang=js"
export * from "./AddConsumptionGaugeWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports